
export default {
  notifications: [],
}
